<h1 matDialogTitle>
  <ng-container *ngIf="!data.id">New box certificate</ng-container>
  <ng-container *ngIf="data.id">Edit box certificate</ng-container>
</h1>
<mat-dialog-content>

  <aw-box-certificate-form [certificate]="data" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-box-certificate-form>

</mat-dialog-content>